import { render, staticRenderFns } from "./leadsTabs.vue?vue&type=template&id=92b162f0&"
import script from "./leadsTabs.vue?vue&type=script&lang=js&"
export * from "./leadsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports